import AppButton from 'shared-module/components/button/AppButton'

const PrimaryButton = (props) => {
  const { id } = props

  return <AppButton {...props} id={id || 'btnSubmit'} color="primary" type="submit" />
}

export default PrimaryButton
